import * as angular from 'angular';
import { ModelModule } from '@mode/legacy/data-access-model-js';
import { SharedUiModule } from '~/modules/shared-ui/shared-ui.module';

import { EditColorPaletteComponent } from './edit-color-palette/edit-color-palette.component';

/* prettier-ignore */
export const ColorPalettesModule = angular
  .module('color-palettes', [ModelModule, SharedUiModule])
  .component('editColorPalette', EditColorPaletteComponent)
  .name;
